<template>
  <div class="container" :class="{ 'brain-adjusted-container': isBrainAdjusted }">
    <div
      @mouseenter="showLayouts = true"
      @mouseleave="showLayouts = false"
      class="global-cover"
      :style="{ height: '10vh', width: '100vw', zIndex: '1000' }"
    >
      <transition name="slide">
        <div v-show="showLayouts"><Layouts /></div>
      </transition>
    </div>

    <div class="content" :class="{ 'content-adjusted': isBrainAdjusted }" v-show="isShowPreContent">
      <!-- 只有未登录用户才显示3D大脑加载动画 -->
      <div v-if="shouldShowBrain3D" class="mycanvas brain-background" :class="{ 'brain-adjusted': isBrainAdjusted }">
        <Brain3DInteractive />
      </div>
      <!-- Splash组件始终显示，包含所有可滚动内容 -->
      <div class="splash-content" v-show="shouldShowSplashContent">
        <Splash 
          ref="splashComponent" 
          :hideFirstContainer="isTextAnimationComplete" 
          @pageChanged="handlePageChange" 
          @textAnimationComplete="handleTextAnimationComplete" 
        />
      </div>
      
      <!-- 当大脑上移时，添加底部填充来避免空白 -->
      <div v-if="isBrainAdjusted && shouldShowBrain3D" class="brain-bottom-filler"></div>
    </div>
    
    <!-- 独立的箭头元素 - 从container中移出 -->
    <div v-if="shouldShowArrow" class="standalone-arrow" @click="handleArrowClick">
      <svg id="more-arrows">
        <polygon class="arrow-top" points="37.6,27.9 1.8,1.3 3.3,0 37.6,25.3 71.9,0 73.7,1.3 " />
        <polygon class="arrow-middle" points="37.6,45.8 0.8,18.7 4.4,16.4 37.6,41.2 71.2,16.4 74.5,18.7 " />
        <polygon class="arrow-bottom" points="37.6,64 0,36.1 5.1,32.8 37.6,56.8 70.4,32.8 75.5,36.1 " />
      </svg>
    </div>
    
    <el-dialog :title="title" custom-class="vision-dialog"  width="1000px" :visible.sync="dialogTableVisible" @close="closeVision">
      <div class="video-con">
        <video id="visionDom" controls autoplay :src="url" />
      </div>
    </el-dialog>
  </div>
</template>

<script>
import store from '@/store'
import { mapState } from 'vuex'
import Brain3DInteractive from '@/components/homepage/brain3d/Brain3DInteractive.vue'
import CommitInfo from '@/components/homepage/commit-info.vue'
import Splash from '@/components/splash-screen/indexHomepage_new.vue'
import Layouts from '@/layouts/BasicLayoutday.vue'
export default {
  data () {
    return {
      isShowPreContent: true,
      isShowCommitInfo: false,
      isShowEmailBox: false,
      isShowJoinBox: true,
      email: '',
      showLayouts: false,
      dialogTableVisible: false,
      url: 'https://bookor-application.oss-cn-beijing.aliyuncs.com/public_video.mp4',
      title: '企业愿景',
      isBrainAdjusted: false,
      isTextAnimationComplete: false // 文字动画是否完成
    }
  },
  components: {
    CommitInfo,
    Brain3DInteractive,
    Splash,
    Layouts
  },
  computed: {
    ...mapState('user', {
      userInfo: (state) => state.userInfo
    }),
    // 检查用户是否已登录
    isUserLoggedIn () {
      return !!(this.userInfo && this.userInfo.userid && localStorage.getItem('authorization'))
    },
    // 控制是否显示3D大脑组件
    shouldShowBrain3D () {
      // 如果用户已登录，不显示大脑加载动画
      return !this.isUserLoggedIn
    },
    // 控制是否显示独立箭头
    shouldShowArrow () {
      // 文字动画完成后且在第一页时显示箭头，或者用户已登录时显示箭头
      return (this.isTextAnimationComplete && !this.isBrainAdjusted) || this.isUserLoggedIn
    },
    // 控制splash-content的显示
    shouldShowSplashContent () {
      // 如果在第二页（introduces），或者文字动画未完成，显示splash-content
      return this.isBrainAdjusted || !this.isTextAnimationComplete
    }
  },
  methods: {
    openVision (type) {
      if (type) {
        this.title = '使用说明'
        this.url = 'https://oss.bookor.com.cn/video/article.mp4'
      } else {
        this.title = '企业愿景'
        this.url = 'https://bookor-application.oss-cn-beijing.aliyuncs.com/public_video.mp4'
      }
      this.dialogTableVisible = true
    },
    closeVision () {
      document.querySelector('#visionDom').pause()
    },
    showEmailBox () {
      this.isShowEmailBox = true
      this.isShowJoinBox = false
    },

    handleEnter () {
      const regex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,63}$/
      if (regex.test(this.email)) {
        this.isShowCommitInfo = true
        this.isShowPreContent = false
      } else {
        this.$message.error({
          message: '请输入正确的邮箱地址',
          duration: 1500
        })
        this.email = ''
      }
    },

    getCodeMes () {
      const code = this.getQueryString('code')
      if (code) {
        this.getLoginMes(code)
      }
    },
    getQueryString (name) {
      var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i')
      var r = window.location.search.substr(1).match(reg)
      if (r != null) {
        return unescape(r[2])
      }
      return ''
    },
    getLoginMes (code) {
      const params = {
        code: code
      }
      const queryParams = new URLSearchParams(params)
      fetch('https://api.bookor.com.cn/index.php/mobile/login/wx_sian_login', {
        method: 'POST',
        body: queryParams
      })
        .then((response) => {
          if (response.ok) {
            return response.json()
          }
          throw new Error('Network response was not ok.')
        })
        .then((data) => {
          if (data.code === 100) {
            this.$message({
              message: '参数错误',
              type: 'error',
              duration: 1000
            })
            window.history.replaceState(
              null,
              null,
              window.location.href.split('?')[0] + window.location.hash
            )
            this.$router.push('/')
          }
          if (data.code === 200) {
            if (typeof data.result === 'string') {
              // 是字符串表示是扫码结果，用户未注册过
              this.$message({
                message: '未绑定微信',
                type: 'error',
                duration: 1000
              })
              window.history.replaceState(
                null,
                null,
                window.location.href.split('?')[0] + window.location.hash
              )
              this.$router.push('/')
            } else {
              localStorage.setItem('authorization', data.result.key)
              localStorage.setItem('userinfo', JSON.stringify(data.result))
              this.$message({
                message: '登录成功',
                type: 'success',
                duration: 1000
              })
              setTimeout(async () => {
                window.history.replaceState(
                  null,
                  null,
                  window.location.href.split('?')[0] + window.location.hash
                )
                this.$router.push('/index')
                await store.dispatch('user/getUserInfoMore')
                // 调用 getUserInfoEnterprise，并等待其完成
                await store.dispatch('user/getUserInfoEnterprise')
                this.$store.commit('user/SET_USERINFO')
              }, 2000)
            }
          }
        })
        .catch((error) => {
          console.error('There was a problem with the network request:', error)
        })
    },
    handlePageChange(page) {
      this.isBrainAdjusted = page === 'introduces'
    },
    // 处理文字动画完成事件
    handleTextAnimationComplete() {
      console.log('文字动画完成，显示独立箭头')
      this.isTextAnimationComplete = true
    },
    // 处理箭头点击事件
    handleArrowClick() {
      // 转发给Splash组件的handleMouseWheel方法
      if (this.$refs.splashComponent) {
        this.$refs.splashComponent.handleMouseWheel()
      }
    }
  },
  mounted () {
    // 检查微信登录授权码
    this.getCodeMes()
    
    // 处理愿景弹框
    const urlParams = new URLSearchParams(window.location.href.split('?')[1])
    const showVision = urlParams.get('showVision')
    if (showVision) {
      this.dialogTableVisible = true
    }
    
    // 如果用户已登录，直接跳转到主界面
    if (this.isUserLoggedIn) {
      console.log('用户已登录，跳过3D大脑加载')
      // 可以直接跳转到用户界面，或者显示简化的首页
      setTimeout(() => {
        this.$router.push('/index')
      }, 1000)
    }
  }
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/global.scss";
.video-con{
  width: 100%;
  display: flex;
  justify-content: center;
  video{
    width: 750px;
  }
}
.container {
  // width: 100vw;
  min-height: 100vh;
  position: relative;
  
  // 当大脑调整位置时，容器也相应调整高度
  &.brain-adjusted-container {
    min-height: 120vh;
  }
  .top-bar {
    @include flex-between;
    width: 100vw;
    height: 10vh;
    background-color: white;
    box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.6); /* 在这里添加阴影 */
    margin: 0 0 10px 0;
    position: absolute;
    top: 0;
    padding: 0 3vw;
    box-sizing: border-box;

    .nav-box {
      display: flex;
      .nav-item {
        margin: 0 4vw 0 0;
        padding: 0 2vw;
        border: 1px solid;
        border-radius: 5px;
        font-size: 14px;
      }
      .nav-lang {
      }
    }
  }
  .content {
    padding-top: 10vh;
    min-height: 90vh;
    width: 100vw;
    position: relative;
    
    // 当大脑调整位置时，内容区域也相应调整
    &.content-adjusted {
      min-height: 110vh; // 增加内容区域高度
    }
    .top-section {
      @include flex-ccc;
      justify-content: flex-end;
      height: 55vh;
      padding-bottom: 40px;
      box-sizing: border-box;
      .top-sent {
        font-size: 55px;
        font-weight: 900;
        font-family: system-ui;
        text-shadow: 1px 0 0 BLACK;
        color: #9ab6c8;
        @include zindex1;
        span {
          font-family: math;
          font-weight: 100;
          font-size: 70px;
        }
      }
      .bottom-sent {
        @include zindex1;
        font-size: 55px;
        span {
          color: #9dc3e6;
          font-weight: 900;
        }
      }
    }
    .bottom-section {
      height: 20vh;
      @include flex-ccc;

      .join {
        // height: 35vh;
        @include flex-ccc;
        justify-content: space-around;
        flex-direction: initial;
        @include zindex1;
        .join-test {
          color: white;
          background-color: black;
          border-radius: 10px;
          padding: 4px 20px;
          font-size: 14px;
          border: 1px white solid;
          box-shadow: 1px 2px 1px rgba(0, 0, 0, 0.5);
          cursor: pointer;
          margin-right: 5vw;
        }
        .join-newread {
          color: black;
          background-color: #d9d9d9;
          border-radius: 10px;
          padding: 4px 14px;
          font-size: 14px;
          border: 1px #000 solid;
          box-shadow: 1px 2px 1px rgba(0, 0, 0, 0.5);
        }
      }
      .email-box {
        @include zindex1;
        color: white;
        background-color: black;
        padding: 4px 14px;
        border-radius: 10px;
        border: 1px white solid;
        box-shadow: 1px 2px 1px rgba(0, 0, 0, 0.5);
        font-size: 14px;
        text-align: center;
      }
      .email-box::placeholder {
        text-align: center; /* 让 placeholder 居中 */
        color: #d7d7d7;
      }
    }
  }
}

.global-cover {
  position: absolute;
  top: 0;
  pointer-events: auto; // 让global-cover能接收鼠标悬停事件
  
  // 确保内部的导航元素也能接收鼠标事件
  * {
    pointer-events: auto;
  }
}

// 3D大脑作为背景
.brain-background {
  position: absolute; // 改为absolute，这样可以影响页面高度
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  z-index: 1;
  pointer-events: auto; // 允许大脑接收鼠标事件
  transition: all 0.5s ease-in-out; // 添加平滑过渡动画
  
  // 确保大脑组件内的所有元素都能接收鼠标事件
  * {
    pointer-events: auto !important;
  }
  
  
}

// Splash组件内容，支持滚动
.splash-content {
  position: relative;
  width: 100vw;
  min-height: 100vh;
  z-index: 2;
  background: transparent;
  pointer-events: none; // 默认让鼠标事件穿透到大脑
  
  // 当3D大脑调整位置时，确保内容区域也相应调整
  .container_box {
    min-height: 120vh; // 确保有足够的高度
    // 容器需要接收滚轮事件，但其他事件穿透
    pointer-events: auto;
    
    // 容器内的装饰性元素默认穿透，但排除大脑组件
    .container {
      pointer-events: none;
      
      // 装饰性元素
      .rectBox,
      .rect,
      .header,
      .slogan,
      .sloganRoad,
      .isShowSloganSecond {
        pointer-events: none;
      }
    }
  }
  
  // 只有特定的交互元素才接收鼠标事件
  .down-arrow,
  .footer-copyright,
  .footer-copyright a,
  .footer-copyright span,
  .footer-copyright p,
  .footer-copyright img,
  button,
  input,
  select,
  textarea,
  a[href],
  [role="button"],
  .clickable {
    pointer-events: auto !important;
  }
}

// 底部填充元素，用于填补大脑上移后的空白
.brain-bottom-filler {
  width: 100vw;
  height: 20vh; // 与大脑上移的距离相匹配
  background: linear-gradient(to bottom, transparent, rgba(10, 10, 26, 0.3)); // 渐变背景，与大脑背景呼应
  position: relative;
  z-index: 0; // 在大脑下方
}

.slide-enter-active,
.slide-leave-active {
  transition: all s;
}

.slide-enter,
.slide-leave-to {
  transform: translate(0, -10vh);
  // opacity: 0;
}

.slide-enter-to,
.slide-leave {
  transform: translate(0, 0);
  // opacity: 1;
}

.video-con{
  width: 100%;
  display: flex;
  justify-content: center;
  video{
    // width: 750px;
    width: 850px;
  }
}
.vision-dialog{
  background-color: #000;
  box-shadow: 0 0 10px 4px rgba(255, 255, 255, 1);
}
.el-dialog__title{
  color: #fff;
}

/* 独立箭头样式 */
.standalone-arrow {
  position: fixed;
  bottom: 10%;
  left: 50%;
  transform: translateX(-50%);
  z-index: 1000;
  cursor: pointer;
  opacity: 0.8;
  transition: opacity 0.3s ease;
}

.standalone-arrow:hover {
  opacity: 1;
}

.standalone-arrow #more-arrows {
  width: 75px;
  height: 65px;
  display: block;
  margin: 0 auto;
  transform: scale(0.4);
}

.standalone-arrow polygon.arrow-top {
  fill: white;
  opacity: 0.6;
  animation: arrow-animation 1s linear infinite;
}

.standalone-arrow polygon.arrow-middle {
  fill: white;
  opacity: 0.7;
  animation: arrow-animation 1s linear infinite 1.3s;
}

.standalone-arrow polygon.arrow-bottom {
  fill: white;
  opacity: 0.8;
  animation: arrow-animation 1s linear infinite 2.5s;
}

@keyframes arrow-animation {
  0% {
    opacity: 0.6;
    transform: translateY(0);
  }
  50% {
    opacity: 1;
    transform: translateY(5px);
  }
  100% {
    opacity: 0.6;
    transform: translateY(0);
  }
}
</style>
